import {Component, Input} from '@angular/core';
import {PolicyInquiryOfferDto} from '../../../bonding_shared';

@Component({
  selector: 'bonus-malus-offer',
  templateUrl: './bonus-malus-offer.component.pug',
})
export class BonusMalusOfferComponent {
  self = this;

  private _offer: PolicyInquiryOfferDto;

  readonly readonly = false;

  @Input() set offer(offer: PolicyInquiryOfferDto) {
    this._offer = offer;
  }

  get offer() {
    return this._offer;
  }

  constructor() {}
}
